// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1rem;
  width: 1rem;
  background: #3B71CA;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #a3a3a3;
}

input[type="range"]:disabled:focus::-webkit-slider-thumb {
  background: #a3a3a3;
}

input[type="range"]:disabled:active::-webkit-slider-thumb {
  background: #a3a3a3;
}

input[type="range"]::-moz-range-thumb {
  height: 1rem;
  width: 1rem;
  background: #3B71CA;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #a3a3a3;
}

input[type="range"]::-moz-range-progress {
  background: #3061AF;
}

input[type="range"]::-ms-fill-lower {
  background: #3061AF;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-thumb {
  background: #3061AF;
}

input[type="range"]:active::-webkit-slider-thumb {
  background: #285192;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 320px) {

  .container {
    max-width: 320px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.end-2 {
  right: 0.5rem;
}
.end-2\\.5 {
  right: 0.625rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/3 {
  left: 33.333333%;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-10 {
  top: 2.5rem;
}
.top-11 {
  top: 2.75rem;
}
.top-5 {
  top: 1.25rem;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.m-6 {
  margin: 1.5rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.me-3 {
  margin-right: 0.75rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-11 {
  margin-left: 2.75rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\/4 {
  height: 25%;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3\\/4 {
  height: 75%;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[560px\\] {
  height: 560px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.min-h-\\[40rem\\] {
  min-height: 40rem;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[664px\\] {
  min-height: 664px;
}
.min-h-\\[75\\%\\] {
  min-height: 75%;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-28 {
  width: 7rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7\\/12 {
  width: 58.333333%;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[156px\\] {
  width: 156px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-md {
  max-width: 28rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-0 {
  flex-grow: 0;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-1\\/6 {
  flex-basis: 16.666667%;
}
.basis-5\\/6 {
  flex-basis: 83.333333%;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-y-4 {
  --tw-border-spacing-y: 1rem;
  border-spacing: var(--tw-border-spacing-x) 1rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(-50%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(0deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(0) scaleY(0);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1.1) scaleY(1.1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.columns-3 {
  -moz-columns: 3;
       columns: 3;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  align-items: center;
  justify-items: center;
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-24 {
  gap: 6rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-32 {
  gap: 8rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - 0));
  margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - 0));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * 0);
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.justify-self-center {
  justify-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  word-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-r-4 {
  border-right-width: 4px;
}
.border-none {
  border-style: none;
}
.border-\\[\\#CCCCCC\\] {
  --tw-border-opacity: 1;
  border-color: rgba(204, 204, 204, 1);
  border-color: rgba(204, 204, 204, var(--tw-border-opacity));
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgba(251, 191, 36, 1);
  border-color: rgba(251, 191, 36, var(--tw-border-opacity));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgba(52, 211, 153, 1);
  border-color: rgba(52, 211, 153, var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}
.border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgba(229, 229, 229, 1);
  border-color: rgba(229, 229, 229, var(--tw-border-opacity));
}
.border-rose-400 {
  --tw-border-opacity: 1;
  border-color: rgba(251, 113, 133, 1);
  border-color: rgba(251, 113, 133, var(--tw-border-opacity));
}
.border-teal-100 {
  --tw-border-opacity: 1;
  border-color: rgba(204, 251, 241, 1);
  border-color: rgba(204, 251, 241, var(--tw-border-opacity));
}
.border-b-gray-200 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(229, 231, 235, 1);
  border-bottom-color: rgba(229, 231, 235, var(--tw-border-opacity));
}
.border-b-neutral-200 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(229, 229, 229, 1);
  border-bottom-color: rgba(229, 229, 229, var(--tw-border-opacity));
}
.border-b-violet-50 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(245, 243, 255, 1);
  border-bottom-color: rgba(245, 243, 255, var(--tw-border-opacity));
}
.border-r-blue-700 {
  --tw-border-opacity: 1;
  border-right-color: rgba(29, 78, 216, 1);
  border-right-color: rgba(29, 78, 216, var(--tw-border-opacity));
}
.border-t-neutral-200 {
  --tw-border-opacity: 1;
  border-top-color: rgba(229, 229, 229, 1);
  border-top-color: rgba(229, 229, 229, var(--tw-border-opacity));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 191, 36, 1);
  background-color: rgba(251, 191, 36, var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, 1);
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(147, 197, 253, 1);
  background-color: rgba(147, 197, 253, var(--tw-bg-opacity));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 246, 255, 1);
  background-color: rgba(239, 246, 255, var(--tw-bg-opacity));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(29, 78, 216, 1);
  background-color: rgba(29, 78, 216, var(--tw-bg-opacity));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(52, 211, 153, 1);
  background-color: rgba(52, 211, 153, var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(249, 250, 251, 1);
  background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(220, 252, 231, 1);
  background-color: rgba(220, 252, 231, var(--tw-bg-opacity));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity));
}
.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(212, 212, 212, 1);
  background-color: rgba(212, 212, 212, var(--tw-bg-opacity));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 237, 213, 1);
  background-color: rgba(255, 237, 213, var(--tw-bg-opacity));
}
.bg-purple-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(192, 132, 252, 1);
  background-color: rgba(192, 132, 252, var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 226, 226, 1);
  background-color: rgba(254, 226, 226, var(--tw-bg-opacity));
}
.bg-rose-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(251, 113, 133, 1);
  background-color: rgba(251, 113, 133, var(--tw-bg-opacity));
}
.bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(51, 65, 85, 1);
  background-color: rgba(51, 65, 85, var(--tw-bg-opacity));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(204, 251, 241, 1);
  background-color: rgba(204, 251, 241, var(--tw-bg-opacity));
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 253, 250, 1);
  background-color: rgba(240, 253, 250, var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 243, 255, 1);
  background-color: rgba(245, 243, 255, var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.fill-blue-600 {
  fill: #2563eb;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-11 {
  padding: 2.75rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-20 {
  padding: 5rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.ps-3 {
  padding-left: 0.75rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-normal {
  line-height: 1.5;
}
.leading-tight {
  line-height: 1.25;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgba(37, 99, 235, 1);
  color: rgba(37, 99, 235, var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgba(29, 78, 216, 1);
  color: rgba(29, 78, 216, var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgba(8, 145, 178, 1);
  color: rgba(8, 145, 178, var(--tw-text-opacity));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgba(52, 211, 153, 1);
  color: rgba(52, 211, 153, var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgba(229, 231, 235, 1);
  color: rgba(229, 231, 235, var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgba(209, 213, 219, 1);
  color: rgba(209, 213, 219, var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, 1);
  color: rgba(55, 65, 81, var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, 1);
  color: rgba(31, 41, 55, var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, 1);
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgba(163, 163, 163, 1);
  color: rgba(163, 163, 163, var(--tw-text-opacity));
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgba(115, 115, 115, 1);
  color: rgba(115, 115, 115, var(--tw-text-opacity));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgba(251, 146, 60, 1);
  color: rgba(251, 146, 60, var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(220, 38, 38, 1);
  color: rgba(220, 38, 38, var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgba(185, 28, 28, 1);
  color: rgba(185, 28, 28, var(--tw-text-opacity));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgba(71, 85, 105, 1);
  color: rgba(71, 85, 105, var(--tw-text-opacity));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgba(15, 23, 42, 1);
  color: rgba(15, 23, 42, var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgba(20, 184, 166, 1);
  color: rgba(20, 184, 166, var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgba(13, 148, 136, 1);
  color: rgba(13, 148, 136, var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgba(15, 118, 110, 1);
  color: rgba(15, 118, 110, var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgba(161, 98, 7, 1);
  color: rgba(161, 98, 7, var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.overline {
  text-decoration-line: overline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-gray-500\\/10 {
  --tw-ring-color: rgba(107, 114, 128, 0.1);
}
.blur-\\[1px\\] {
  --tw-blur: blur(1px);
  filter: blur(1px) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-150 {
  --tw-brightness: brightness(1.5);
  filter: var(--tw-blur) brightness(1.5) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-50 {
  --tw-brightness: brightness(.5);
  filter: var(--tw-blur) brightness(.5) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[1px_1px_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\] {
  --tw-drop-shadow: drop-shadow(1px 1px rgba(0,0,0,1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) drop-shadow(1px 1px rgba(0,0,0,1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
ul:not([name=nav-items]) {
  list-style-type: disc;
  padding-left: 2rem;
}

.sumsentence {
  margin-left: 0.25rem;
}

.mr-1 {
  margin-right: 0rem;
}

div {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.current-page {
  border-right-width: 4px;
  --tw-border-opacity: 1;
  border-right-color: rgba(29, 78, 216, 1);
  border-right-color: rgba(29, 78, 216, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(245, 243, 255, 1);
  background-color: rgba(245, 243, 255, var(--tw-bg-opacity));
}

body {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 243, 255, 1);
  background-color: rgba(245, 243, 255, var(--tw-bg-opacity));
  height: 100vh;
}

.dataTables_wrapper {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}

.dataTables_paginate {
  margin-top: 0.5rem;
}

.dataTables_info {
  margin-top: 0.5rem;
}

body,
html {
  height: 100%;
  width: 100%;
  margin: 0;
  overscroll-behavior: none;
}

tbody * {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}

.btn, .btn--warning {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgba(29, 78, 216, 1);
  background-color: rgba(29, 78, 216, var(--tw-bg-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  .btn, .btn--warning {
    height: 2.75rem;
  }
}

.btn:disabled, .btn--warning:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(96, 165, 250, 1);
  background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
}
.btn--warning {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, 1);
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));
}
.btn--warning:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 113, 113, 1);
  background-color: rgba(248, 113, 113, var(--tw-bg-opacity));
}

.delete {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0.25em 0.5em;
}
.delete:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(75, 85, 99, 1);
  background-color: rgba(75, 85, 99, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.pill-input {
  flex: 0 0 auto;
  padding: 0 0.5em 0 0.75em;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  position: relative;
  max-width: 95%;
  margin-bottom: 0.25em;
  --tw-bg-opacity: 1;
  background-color: rgba(209, 213, 219, 1);
  background-color: rgba(209, 213, 219, var(--tw-bg-opacity));
}
.pill-input:not(:last-child) {
  margin-right: 0.5em;
}

.topic-keyword-input {
  display: flex;
  line-height: 2em;
  border: none;
  background: none;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  width: 100%;
}
.topic-keyword-input:focus {
  outline: none;
}

.secondary-widget-heading {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

#dashboard-active-topics th,
#source-list-container th {
  padding: 1rem;
  font-weight: 500;
}
#dashboard-active-topics td,
#source-list-container td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
#dashboard-active-topics td.archived,
#source-list-container td.archived {
  --tw-text-opacity: 1;
  color: rgba(245, 158, 11, 1);
  color: rgba(245, 158, 11, var(--tw-text-opacity));
}

.underline-link {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(29, 78, 216, 1);
  color: rgba(29, 78, 216, var(--tw-text-opacity));
  text-decoration-line: underline;
}

#popover-actions-menu {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
  position: absolute;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: none;
  z-index: 1;
  min-width: 100px;
}

.popover-option {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: rgba(239, 246, 255, 1);
  border-bottom-color: rgba(239, 246, 255, var(--tw-border-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 0.5rem;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  cursor: pointer;
}
.popover-option i {
  margin-right: 0.75rem;
}

.popover-option:hover {
  background-color: #f0f0f0;
}

.ellipsis-button {
  cursor: pointer;
}

#popover-add-source,
#popover-edit-source,
#popover-delete-source {
  position: absolute;
  z-index: 10;
  display: none;
  transform: translate(-50%, -50%);
}

.overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

table.dataTable tbody td {
  vertical-align: top;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}

.after\\:left-0\\.5::after {
  content: var(--tw-content);
  left: 0.125rem;
}

.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}

.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, 1);
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: '';
  content: var(--tw-content);
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:border-teal-200:hover {
  --tw-border-opacity: 1;
  border-color: rgba(153, 246, 228, 1);
  border-color: rgba(153, 246, 228, var(--tw-border-opacity));
}

.hover\\:bg-blue-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(30, 58, 138, 1);
  background-color: rgba(30, 58, 138, var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, 1);
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, 1);
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(156, 163, 175, 1);
  background-color: rgba(156, 163, 175, var(--tw-bg-opacity));
}

.hover\\:bg-neutral-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity));
}

.hover\\:bg-neutral-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 229, 229, 1);
  background-color: rgba(229, 229, 229, var(--tw-bg-opacity));
}

.hover\\:bg-teal-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(204, 251, 241, 1);
  background-color: rgba(204, 251, 241, var(--tw-bg-opacity));
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgba(30, 58, 138, 1);
  color: rgba(30, 58, 138, var(--tw-text-opacity));
}

.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, 1);
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, 1);
  color: rgba(31, 41, 55, var(--tw-text-opacity));
}

.hover\\:no-underline:hover {
  text-decoration-line: none;
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(59, 130, 246, 1);
  border-color: rgba(59, 130, 246, var(--tw-border-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity));
}

.active\\:outline-none:active {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.disabled\\:bg-blue-400:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(96, 165, 250, 1);
  background-color: rgba(96, 165, 250, var(--tw-bg-opacity));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(1) scaleY(1);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(147, 197, 253, 1);
  background-color: rgba(147, 197, 253, var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-5::after {
  content: var(--tw-content);
  --tw-translate-x: 1.25rem;
  transform: translate(1.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.peer:focus ~ .peer-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color), var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color), 0 0 rgba(0,0,0,0);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}

.peer:focus ~ .peer-focus\\:ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(147, 197, 253, var(--tw-ring-opacity));
}

[dir="rtl"] .rtl\\:text-right {
  text-align: right;
}

.dark .dark\\:border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgba(75, 85, 99, 1);
  border-color: rgba(75, 85, 99, var(--tw-border-opacity));
}

.dark .dark\\:border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgba(55, 65, 81, 1);
  border-color: rgba(55, 65, 81, var(--tw-border-opacity));
}

.dark .dark\\:bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}

.dark .dark\\:bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgba(31, 41, 55, 1);
  background-color: rgba(31, 41, 55, var(--tw-bg-opacity));
}

.dark .dark\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}

.dark .dark\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgba(75, 85, 99, 1);
  color: rgba(75, 85, 99, var(--tw-text-opacity));
}

.dark .dark\\:text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.dark .dark\\:placeholder-gray-400::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-placeholder-opacity));
}

.dark .dark\\:placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(156, 163, 175, 1);
  color: rgba(156, 163, 175, var(--tw-placeholder-opacity));
}

.dark .dark\\:hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, 1);
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}

.dark .dark\\:focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(59, 130, 246, 1);
  border-color: rgba(59, 130, 246, var(--tw-border-opacity));
}

.dark .dark\\:focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity));
}

.dark .peer:focus ~ .dark\\:peer-focus\\:ring-blue-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(30, 64, 175, var(--tw-ring-opacity));
}

@media (min-width: 320px) {

  .xs\\:w-\\[85\\%\\] {
    width: 85%;
  }
}

@media (min-width: 640px) {

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * 0);
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * (1 - 0));
    margin-left: calc(1.25rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - 0));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 768px) {

  .md\\:flex-row {
    flex-direction: row;
  }
}

@media (min-width: 1024px) {

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-1\\/6 {
    width: 16.666667%;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }

  .lg\\:w-5\\/6 {
    width: 83.333333%;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:p-16 {
    padding: 4rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:pt-32 {
    padding-top: 8rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:ml-6 {
    margin-left: 1.5rem;
  }

  .xl\\:w-1\\/4 {
    width: 25%;
  }

  .xl\\:w-1\\/6 {
    width: 16.666667%;
  }

  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .xl\\:w-3\\/4 {
    width: 75%;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:gap-2 {
    gap: 0.5rem;
  }

  .xl\\:gap-8 {
    gap: 2rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .\\32xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .\\32xl\\:flex {
    display: flex;
  }

  .\\32xl\\:w-1\\/2 {
    width: 50%;
  }

  .\\32xl\\:flex-col {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/styles.scss"],"names":[],"mappings":"AACA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;CAAA;;AAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,0BAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,oCAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,YAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,SAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,YAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,SAAA;EAAA,gBAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,+CAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8KAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,6KAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,mLAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,qLAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,oLAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA,+JAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,mKAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;KAAA,qBAAA;UAAA;AAAA;AAAA;EAAA,eAAA;OAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,kCAAA;EAAA,0DAAA;EAAA,sCAAA;EAAA,8DAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,mCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,2CAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,2CAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,2CAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;KAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mFAAA;EAAA,mGAAA;EAAA,wHAAA;EAAA;AAAA;AAAA;EAAA,iFAAA;EAAA,iGAAA;EAAA,sHAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA,iFAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA,0MAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA,0MAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,4KAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA,4KAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA,2KAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA,8LAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAMA;EACE,qBAAA;EACA,kBAAA;AALF;;AAOA;EACE,oBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAQE;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;;AAIA;EAAA,uBAAA;EAAA,sBAAA;EAAA,wCAAA;EAAA,+DAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;EACA;AADA;;AAKA;EAAA,sBAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAIA;EAAA;AAAA;;AAGF;;EAEE,YAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AAJF;;AAQE;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;;AAIA;EAAA,sBAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,yDAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;;AAAA;;EAAA;IAAA;EAAA;AAAA;;AACA;EAAA,kBAAA;EAAA,uCAAA;EAAA;AAAA;AAIE;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;;AAIJ;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AANF;AASI;EAAA,kBAAA;EAAA,qCAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;;AAIJ;EACE,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EAEA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;AARF;AAUE;EACE,mBAAA;AARJ;;AAYA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,WAAA;AATF;AAWE;EACE,aAAA;AATJ;;AAcE;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA;AAAA;;AAME;;EAAA,aAAA;EAAA;AAAA;AAIA;;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAIA;;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;;AAKF;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA,gDAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,uBAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA,kDAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,UAAA;EACA;AALA;;AASA;EAAA,wBAAA;EAAA,sBAAA;EAAA,2CAAA;EAAA,kEAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,gBAAA;EACA;AADA;AAIE;EAAA;AAAA;;AAIJ;EACE,yBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;;;EAGE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAzKA;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD,sBAyKC;EAzKD,oCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD,wBAyKC;EAzKD,wDAyKC;EAzKD;AAyKC;;AAzKD;EAAA,gBAyKC;EAzKD,WAyKC;EAzKD;AAyKC;;AAzKD;EAAA;AAyKC;;AAzKD;EAAA,sBAyKC;EAzKD,oCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,sCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,uBAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,2BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,6BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA;AAyKC;;AAzKD;EAAA,sBAyKC;EAzKD,mCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,8BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,2GAyKC;EAzKD,yGAyKC;EAzKD,0MAyKC;EAzKD;AAyKC;;AAzKD;EAAA,2GAyKC;EAzKD,yGAyKC;EAzKD,0MAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD;AAyKC;;AAzKD;EAAA,8BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,uCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,eAyKC;EAzKD,eAyKC;EAzKD,+JAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,wCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD,yBAyKC;EAzKD,iLAyKC;EAzKD;AAyKC;;AAzKD;EAAA,0BAyKC;EAzKD,sBAyKC;EAzKD,oCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,8BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,2GAyKC;EAzKD,yGAyKC;EAzKD,0MAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD;AAyKC;;AAzKD;EAAA;AAyKC;;AAzKD;EAAA,sBAyKC;EAzKD,iCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,sBAyKC;EAzKD,iCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,qCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,qCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,6BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,0BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD,6BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,2BAyKC;EAzKD,6BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,2BAyKC;EAzKD,6BAyKC;EAzKD;AAyKC;;AAzKD;EAAA,kBAyKC;EAzKD,qCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,sBAyKC;EAzKD,mCAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD;AAyKC;;AAzKD;EAAA,oBAyKC;EAzKD;AAyKC;;AAzKD;;EAAA;IAAA;EAyKC;AAAA;;AAzKD;;EAAA;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA,uBAyKC;IAzKD,+BAyKC;IAzKD,uDAyKC;IAzKD,oCAyKC;IAzKD,4DAyKC;IAzKD,wCAyKC;IAzKD;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA,oBAyKC;IAzKD;EAyKC;AAAA;;AAzKD;;EAAA;IAAA;EAyKC;AAAA;;AAzKD;;EAAA;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA,kBAyKC;IAzKD;EAyKC;;EAzKD;IAAA;EAyKC;AAAA;;AAzKD;;EAAA;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA,mBAyKC;IAzKD;EAyKC;AAAA;;AAzKD;;EAAA;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;;EAzKD;IAAA;EAyKC;AAAA","sourcesContent":["@use \"variables\" as *;\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n// body {\n//     background-color: $highlight-color;\n// }\n\nul:not([name=\"nav-items\"]) {\n  list-style-type: disc;\n  padding-left: 2rem;\n}\n.sumsentence {\n  margin-left: 0.25rem;\n}\n\n.mr-1 {\n  margin-right: 0rem;\n}\n\ndiv {\n  @apply text-white;\n}\n\n.current-page {\n  @apply bg-violet-50 border-r-4 border-r-blue-700;\n}\n\nbody {\n  @apply bg-violet-50;\n  @apply h-screen;\n}\n\n.dataTables_wrapper {\n  @apply text-gray-500 bg-white p-6 rounded;\n}\n\n.dataTables_paginate {\n  @apply mt-2;\n}\n\n.dataTables_info {\n  @apply mt-2;\n}\n\nbody,\nhtml {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  overscroll-behavior: none;\n}\n\ntbody * {\n  @apply text-gray-500;\n}\n\n.btn {\n  @apply bg-blue-700 text-white py-2.5 px-4 rounded lg:h-11;\n  @apply disabled:bg-blue-400;\n\n  &--warning {\n    @extend .btn;\n    @apply bg-red-500 disabled:bg-red-400;\n  }\n}\n\n.delete {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  margin: 0.25em 0.5em;\n\n  &:hover {\n    @apply bg-gray-600 text-white;\n  }\n}\n\n.pill-input {\n  flex: 0 0 auto;\n  padding: 0 0.5em 0 0.75em;\n  border-radius: 100px;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  max-width: 95%;\n  margin-bottom: 0.25em;\n\n  @apply bg-gray-300;\n\n  &:not(:last-child) {\n    margin-right: 0.5em;\n  }\n}\n\n.topic-keyword-input {\n  display: flex;\n  line-height: 2em;\n  border: none;\n  background: none;\n  appearance: none;\n  width: 100%;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.secondary-widget-heading {\n  @apply text-black text-lg font-semibold;\n}\n\n#dashboard-active-topics,\n#source-list-container {\n  th {\n    @apply p-4 font-medium;\n  }\n\n  td {\n    @apply px-4 py-5 font-medium text-gray-500;\n  }\n\n  td.archived {\n    @apply text-amber-500;\n  }\n}\n\n.underline-link {\n  @apply text-blue-700 text-sm underline font-medium;\n}\n\n#popover-actions-menu {\n  @apply pt-4 px-4 pb-5 bg-white text-gray-500;\n  position: absolute;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  display: none;\n  z-index: 1;\n  min-width: 100px;\n}\n\n.popover-option {\n  @apply py-2 pr-2 border-b border-b-blue-50 text-left text-sm font-medium;\n  cursor: pointer;\n\n  i {\n    @apply mr-3;\n  }\n}\n\n.popover-option:hover {\n  background-color: #f0f0f0;\n}\n\n.ellipsis-button {\n  cursor: pointer;\n}\n\n#popover-add-source,\n#popover-edit-source,\n#popover-delete-source {\n  position: absolute;\n  z-index: 10;\n  display: none;\n  transform: translate(-50%, -50%);\n}\n\n.overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9;\n}\n\ntable.dataTable tbody td {\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
